import React, {useMemo} from 'react';


import {BasicPage} from 'src/components/basic-page';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';

import {Group} from '@pb/kit-component-group';

import {ConferenceTabs} from '../conference-tabs';
import {CONFERENCE_SUB_TABS} from '../constants';

import {Searches} from './components/searches';
import {Sections} from './components/sections';

export const SECTION_NAME = 'Content Management';

type Props = {
    accountId: number,
    conferenceId: number,
};

export const Content = ({accountId, conferenceId}: Props) => {
    const {hasAccess} = useAdminAccessRight();

    const editable = useMemo(() => hasAccess(ACCESS_RIGHTS.CONFERENCE_EDIT), [hasAccess]);

    return (
        <>
            <ConferenceTabs accountId={accountId} activeSubTab={CONFERENCE_SUB_TABS.CONTENT.name}/>
            <BasicPage title="Content Management" buttonsBlock={<div/>}>
                <div className="pd-l">
                    <Group direction="v" gap="xl" alignItems="start">
                        <Sections
                            conferenceId={conferenceId}
                            readonly={!editable}
                        />
                        <Searches
                            conferenceId={conferenceId}
                            readonly={!editable}
                        />
                    </Group>
                </div>
            </BasicPage>
        </>
    );
};
